import React from "react";
import PropTypes from "prop-types";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/classNames";

const chipVariants = cva("sp-chip", {
  variants: {
    variant: {
      outline: "sp-chip--outline",
      "outline-dark": "sp-chip--outline-dark",
      overlay: "sp-chip--overlay",
      muted: "sp-chip--muted",
      network: "sp-chip--network",
      primary: "sp-chip--primary",
      success: "sp-chip--success",
      warning: "sp-chip--warning",
    },
    size: {
      default: "",
      badge: "sp-chip--badge",
    },
  },
  defaultVariants: {
    variant: "outline",
    size: "default",
  },
});

const Chip = React.forwardRef(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <span
        className={cn(chipVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Chip.displayName = "Chip";

Chip.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    "outline",
    "outline-dark",
    "overlay",
    "muted",
    "network",
    "primary",
    "success",
    "warning"
  ]),
  size: PropTypes.oneOf(["default", "badge"]),
  children: PropTypes.node.isRequired,
};

export { Chip, chipVariants };
export default Chip;
